<div class="d-flex justify-content-between align-items-center">
  <button class="cancel-button btn btn-primary" (click)="onSubmit()">
    <i class="bi bi-eye p-2"></i>
  </button>
</div>
